import * as R from 'ramda';

export const pointDefault = color => ({
    fill: false,
    lineTension: 0,
    backgroundColor: color,
    borderColor: color,
    borderCapStyle: 'butt',
    borderWidth: 1.5,
    borderDash: [],
    borderDashOffset: 0.0,
    borderJoinStyle: 'miter',
    pointBorderColor: '#fff',
    pointBackgroundColor: color,
    pointBorderWidth: 1,
    pointHoverRadius: 2,
    pointHoverBackgroundColor: color,
    pointHoverBorderColor: color,
    pointHoverBorderWidth: 2,
    pointRadius: 10,
    pointStyle: [],
    pointHitRadius: 10,
});

const mapIndexed = R.addIndex(R.map);
export const appendColor = mapIndexed((set, index) =>
    R.merge(pointDefault(set.color, index), set),
);
